import { Atributo } from './atributos.model';

export enum DescriptionTypes {
  MARKETING = 'MARKETING',
  CREDITO = 'CREDITO',
  FRAUDE = 'FRAUDE',
  DATA_QUALITY = 'DATA_QUALITY',
  CLARO = 'CLARO',
  CERTIFICADO_DIGITAL = "CERTIFICADO_DIGITAL",
  SCR = "SCR",
}

export enum DescriptionBlocks {
  DADOSCADASTRAIS = 'DADOS CADASTRAIS',
  IDENTIFICACAO = 'DADOS DE IDENTIFICAÇÃO',
  DADOSLOCALIZACAO = 'DADOS DE LOCALIZAÇÃO',
  OUTROSDADOSCADASTRAIS = 'OUTROS DADOS CADASTRAIS',
  PARTICIPACAOSOCIETARIA = 'DADOS DE PARTICIPAÇÃO SOCIETÁRIA',
  DADOSCONSULTACREDITO = 'CONSULTAS AO CPF',
  DADOSCONSULTALOCKUNLOCK = 'CONSULTAS À SERASA - LOCK&UNLOCK',
  DADOSCONSULTACERTIFICADO = 'DADOS DE CERTIFICADO DIGITAL',
  DADOSDOCUMENTOSEXTRAVIADOS = 'DADOS DE DOCUMENTOS EXTRAVIADOS',
  DADOSSCR = 'DADOS SCR - BACEN'
}

export class Finalidades {
  description: string;
  id: string;
  name: string;
  columnAttributes: Atributo[] = [];
  reasons: string[] = [];
}

export class FinalidadesClaro {
  description: string;
  id: string;
  name: string;
  attributes: string[] = [];
  reasons: string[] = [];
}
